var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.615-120q-26.846 0-45.731-18.884Q200-157.769 200-184.615v-350.77q0-26.846 18.884-45.731Q237.769-600 264.615-600H320v-80q0-66.846 46.577-113.423T480-840q66.846 0 113.423 46.577T640-680v80h55.385q26.846 0 45.731 18.884Q760-562.231 760-535.385v350.77q0 26.846-18.884 45.731Q722.231-120 695.385-120h-430.77Zm0-40h430.77q10.769 0 17.692-6.923T720-184.615v-350.77q0-10.769-6.923-17.692T695.385-560h-430.77q-10.769 0-17.692 6.923T240-535.385v350.77q0 10.769 6.923 17.692T264.615-160ZM480-300q25.308 0 42.654-17.346Q540-334.692 540-360q0-25.308-17.346-42.654Q505.308-420 480-420q-25.308 0-42.654 17.346Q420-385.308 420-360q0 25.308 17.346 42.654Q454.692-300 480-300ZM360-600h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ecf53377e25a114498fbb50693663549.svg";
export { ForwardRef as ReactComponent };